import PaginateButton from "../../../../shared/PaginateButton/PaginateButton";
import { loadUsers } from "../../../../store/features/AdminPanel/User/UserApi";
import { setCurrentPage, usersPaginate } from "../../../../store/features/AdminPanel/User/UserSlice";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import "./userFooter.scss";

const UserFooter = () => {
  const dispatch = useAppDispatch();
  const userState: any = useAppSelector((store: RootStore) => {
    return store.UserSlice;
  });
  const handlePagination = (num: number) => {
    // dispatch(usersPaginate(num));
    console.log(num);
    dispatch(setCurrentPage(num+1))
    // dispatch(loadUsers({page:num+1}))
  };
  //   usersPaginate;
  return (
    <div className="pagination__section">
      <PaginateButton
        paginate={handlePagination}
        totalRows={userState?.pagination_data?.total}
      />
    </div>
  );
};

export default UserFooter;
